var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InPageNav',{attrs:{"options":[
				{
					text : 'Generate configs',
					path : '/templates/'+_vm.template.id,
				},
				{
					text : 'Edit template',
					path : '/templates/'+_vm.template.id+'/edit',
				},
				{
					text : 'Saved Configs',
					path : '/templates/'+_vm.template.id+'/configs',
				} ]}})}
var staticRenderFns = []

export { render, staticRenderFns }